const IconClose = ({ height = 32, width = 32 }: { height?: number; width?: number }) => (
  <svg fill="none" height={height} viewBox="0 0 32 32" width={width} xmlns="http://www.w3.org/2000/svg">
    <path d="M24 8 8 24M8 8l16 16" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);

export default IconClose;
